export default "__VITE_ASSET__1f2511a0__"